import React, { useEffect, useState } from "react";
import { animals } from "../data.js";
import "../App.css";
import { convertAnimal } from "../converter";
import { AnimalPage } from "../Component/AnimalPage";


export const AnimalPageContainer = () => {
    const [animalList, setAnimalList] = useState(animals);
    const [searchWords, setSearchWords] = useState("");
    
    // useEffect(()=>{
    //     fetch("https://zoo-animal-api.herokuapp.com/animals/rand/10")
    //     .then((res) => res.json())
    //     .then((data)=> setAnimalList(convertAnimal(data)))
    // }, [])
    
    useEffect(() =>{
        const loweredSearchedWords = searchWords.toLowerCase();
        const updatedAnimalList = [];
        if (searchWords !== "") {
            animals.forEach((animal) => {
            const loweredAnimalName = animal.name.toLowerCase();
            if (loweredAnimalName.includes(loweredSearchedWords)){
            updatedAnimalList.push(animal);
            }
        })
            setAnimalList(updatedAnimalList);
        } else {
            setAnimalList(animals);
        }
    }, [animals, searchWords]) 
    
    // const handleSearchAnimal = (text) => {
    //     const loweredSearchWords = text.toLowerCase();
    //     const updatedAnimalList = [];
    
    //     if(text !== ""){
    //         animalList.forEach((animal: (...)) => {
    //             const loweredSearchWords = animal.name.toLowerCase();
    //             if(loweredSearchWords.includes(loweredSearchWords)){
    //                 updatedAnimalList.push(animal);
    //             }
    //         });
    //         setAnimalList(updatedAnimalList)
    //     } else {
    //         setAnimalList(animals)
    //     }
    // }
    
    

    return(
        <AnimalPage animalList={animalList}
                    searchWords={searchWords}
                    setSearchWords={setSearchWords}/>
    )
}
